import React, { useEffect, useState, useContext } from 'react';
import PropTypes from 'prop-types';

import {
	makeStyles,
	Typography
} from '@material-ui/core';

import Fido from "../utils/Fido";
import Constants from "../utils/Constants";
import FilterSelect from "../components/FilterSelect";
import EmailSentimentBehindNumbers from "../reports/components/EmailSentimentBehindNumbers";
import OverviewReportLayout from "../reports/components/OverviewReportLayout";
import EmailSentimentReportItem from "../reports/components/EmailSentimentReportItem";
import AuthorizedUser from "../utils/AuthorizedUser";
import AuthorizedUserContext from "../utils/AuthorizedUserContext";

const styles = makeStyles(theme => ({

}));

function StudentSentiment(props) {
	const authenticatedUser = useContext(AuthorizedUserContext);

	const [sentimentData, setSentimentData] = useState(null);
	const [sentimentFidoError, setSentimentFidoError] = useState(false);
	const [previousDays, setPreviousDays] = useState([90]);

	let classes = styles(),
		{updateHeader, resetHeader, location, showSnackbar} = props,
		hasGmail = AuthorizedUser.hasGmailSentiment(authenticatedUser),
		hasExchange = AuthorizedUser.hasExchangeSentiment(authenticatedUser),
		hasBoth = hasGmail && hasExchange,
		displayNames = Constants.SOURCES.DISPLAY_NAMES;

	const [sourceId, setSourceId] = useState(hasBoth || hasGmail ? Constants.SOURCES.IDS.GMAIL : Constants.SOURCES.IDS.EXCHANGE);

	useEffect(() => {
		updateHeader({title: "email sentiment", primary: true});
		return () => resetHeader();
	}, [updateHeader, resetHeader]);

	useEffect(() => {
		let fido = new Fido();

		(async function load() {
			setSentimentData(null);
			let data = await fido.fetch("/reports/email-sentiment", {
				query: {
					sourceId: sourceId,
					previousDays: previousDays[0]
				}
			})
				.catch(error => {
					setSentimentFidoError(true);
					return showSnackbar(error.message);
				});

			if (data) {
				setSentimentData(data);
			}
		})();

		return () => fido.dropIt();
	}, [setSentimentData, setSentimentFidoError, showSnackbar, previousDays, sourceId]);

	const executeFilter = (filterObj) => {
		if (filterObj.previousDays[0] !== previousDays[0]) {
			setPreviousDays(filterObj.previousDays);
		}
	};

	const filterSource = (selected) => {
		if (selected.source[0] !== sourceId) {
			setSourceId(selected.source[0]);
		}
	};

	let defaultSelection = hasBoth ? [Constants.SOURCES.IDS.GMAIL] : null,
		filterTitle = sourceId === Constants.SOURCES.IDS.GMAIL ? displayNames[Constants.SOURCES.GMAIL] : displayNames[Constants.SOURCES.EXCHANGE],
		filterFields = hasBoth ? [
			<FilterSelect
				key="sourceFilter"
				singleSelect
				name="source"
				options={[{
					id: Constants.SOURCES.IDS.GMAIL,
					name: displayNames[Constants.SOURCES.GMAIL]
				},{
					id: Constants.SOURCES.IDS.EXCHANGE,
					name: displayNames[Constants.SOURCES.EXCHANGE]
				}]}
				defaultSelections={defaultSelection}
				menuTitle={filterTitle}
				handleUpdate={filterSource} />
		] : null;

	return (
		<OverviewReportLayout
			showAccounts={false}
			location={location}
			forcePreviousDays
			previousDays={previousDays[0]}
			filterCallback={executeFilter}
			extraFilterFields={filterFields}
			defaultSelection={Constants.REPORT.DAYS[4]}
			daysOptions={Constants.REPORT.DAYS.filter((item, idx) => idx !== 0)}>
			<EmailSentimentReportItem
				fullWidth
				data={sentimentData}
				previousDays={previousDays[0]}
				useMoreInfoDialog={false}
				fidoError={sentimentFidoError}
				reportTitle={`${filterTitle} Sentiment`} />
			<Typography className={classes.numbersTitle} variant="subtitle1">Behind The Numbers</Typography>
			<EmailSentimentBehindNumbers fullWidth />
		</OverviewReportLayout>
	);
}

StudentSentiment.propTypes = {
	location: PropTypes.object,
	updateHeader: PropTypes.func.isRequired,
	resetHeader: PropTypes.func.isRequired,
	showSnackbar: PropTypes.func.isRequired
};

export default StudentSentiment;